import store from '../config/configureStore';

import Cookies from 'js-cookie';

import { detectClientIP, getDataOfDictionaryOptions } from 'utils/functions';
import { resetRestClient } from '../restClient';
import { notify } from './NotifierReducer';
import { getDictionaries } from './DictionaryReducer';
import { updateIfNewVersionAvail, checkForNewVersion, updateApp } from './AppInfoReducer';
import { formatSaveDate } from 'reducers/TimeReducer';
import {
  resetIncidentFilter,
  setOccuredFromDate,
  setOccuredToDate,
  setOccurredTimePeriodValue,
} from 'reducers/ui/UIHomeScreenReducer';
import { resetUserPermissions } from '../reducers/PermissionsReducer';
import { getTimePeriod } from 'reducers/TimeReducer';
import { handleError } from './ErrorReducer';
import { findUnreadUserBulletins } from 'reducers/BulletinReducer';
import {
  setIsWarningCitation,
  setLastCourteDetails,
  setIsSubmittedCitation,
} from './CitationReducer';
import { setMode } from './ThemeReducer';
import { setIsViewError, setViewSubStatus } from './IBRSReducer';
// User
export const USER_SET_AUTHENTICATED = 'USER/SET_AUTHENTICATED';
export const USER_SECOND_FACTOR = 'USER/USER_SECOND_FACTOR';
export const USER_SET_DATA = 'USER/SET_DATA';
export const USER_SET_AGENCY = 'USER/SET_AGENCY';
export const USER_SET_INCIDENT_REPORT_VERSION = 'USER/SET_INCIDENT_REPORT_VERSION';
export const USER_SET_EVIDENCE_LABEL_REPORT_VERSION = 'USER/SET_EVIDENCE_LABEL_REPORT_VERSION';
export const USER_SET_CLEARANCE_LEVEL = 'USER/SET_CLEARANCE_LEVEL';
export const USER_SET_CLEARANCE_OPTIONS = 'USER/SET_CLEARANCE_OPTIONS';
export const USER_CLEAR_DATA = 'USER/USER_CLEAR_DATA';
export const USER_AGENCY_NIBRS_VERSION = 'USER/AGENCY_NIBRS_VERSION';
export const USER_AGENCY_SUBMISSON_FILE_FORMAT = 'USER/AGENCY_SUBMISSON_FILE_FORMAT';

const PASSWORD_FIELD_SHOULD_RESET = 'PASSWORD_FIELD_SHOULD_RESET';

let logOutSent = false;

const defaultState = {
  // User
  isAuthenticated: false,
  userData: null,
  userAgency: '',
  incidentReportVersion: '',
  evidenceLabelReportVersion: '',
  userCurrentClearanceLevel: { Level: '', Description: '' },
  userClearanceOptions: [],
  ibrsVersion: 'NIBRS',
  submissionFileFormat: 'SINGLE',
  secondFactor: false,
};

const filter = {
  incidentFilter: {
    sortBy: '',
    groupBy: '',
    incidentListCurrentView: 'incidentCardView',
    expandOrNotValue: false,
    occuredFrom: null,
    occuredTo: null,
    occurredTimePeriod: '',
    receivedTimePeriod: '',
    receivedFrom: null,
    receivedTo: null,
    quickFilter: '',
    ptsUserIdShareFilter: null,
    filterForm: {
      placeOrAddress: '',
      lowBlock: '',
      highBlock: '',
      predirectional: '',
      streetName: '',
      postdirectional: '',
      streetType: '',
      unitType: '',
      unitNumber: '',
      city: '',
      zone: '',
      partyType: '',
      partyName: '',
      lastName: '',
      firstName: '',
      middleName: '',
      contactMethod: '',
      contactInfo: '',
      cadEventNumber: '',
      status: '',
      tagType: '',
      tagValue: '',
      offense: '',
      disposition: '',
    },
    gridFilters: {
      rowFilterModel: {
        items: [],
        linkOperator: 'and',
      },
      columnVisibleModel: {
        actions: true,
        address: true,
        agency: true,
        assignedOfficer: true,
        eventType: true,
        incidentNumber: true,
        lastUpdated: true,
        occurredDate: true,
      },
      pinnedColumns: {
        left: [],
        right: [],
      },
      sortingModels: [],
      groupFilterKey: '',
    },
  },
};

export const saveUserSettings = async (params) => {
  const state = store.store.getState();
  const client = state.websocket.websocket;
  const courtDetails = state.citation.lastCourtDetails;
  const { incidentFilter } = state.uiHomeScreen;
  const settings = { incidentFilter: incidentFilter };
  const { ibrsFilter } = state.ibrs;
  const ibrsPayload = {
    isViewError: ibrsFilter?.isViewError ?? 'all',
    viewSubStatus: ibrsFilter?.viewSubStatus ?? 'all',
  };
  const payload = { ...settings };
  payload.lastCourtDetails = params?.courtDetails || courtDetails || null;
  payload.isWarningCitation = state.citation?.citationFilters?.isWarningCitation;
  payload.isSubmittedCitation = state.citation?.citationFilters?.isSubmittedCitation;
  payload.ibrsFilter = { ...ibrsPayload };
  payload.evidencePreferenceSetting = state.userSettings.evidencePreferenceSetting || null;
  const jsonValue = JSON.stringify(payload);
  let userSettings = [];
  let response;

  try {
    if (!client) {
      return;
    }

    const service = client.service('user-settings');
    service.timeout = 20000;

    if (state.user.userData?.user.UserSettings) {
      userSettings = JSON.parse(state.user.userData?.user.UserSettings);
      let ptsUserSettingID;

      userSettings.map((setting) => {
        if (setting.SettingApp === 'RMS' || setting.ApplicationName === 'RMS') {
          setting.JsonValue = jsonValue;
          ptsUserSettingID = setting.ptsUserSettingID;
        }

        return setting;
      });

      state.user.userData.user.UserSettings = JSON.stringify(userSettings);

      response = await service.patch(ptsUserSettingID, {
        JsonValue: jsonValue,
      });
    }
  } catch (err) {
    console.log('error', err);
  }
};

export const resetUserSettings = async () => {
  const state = store.store.getState();
  const client = state.websocket.websocket;

  try {
    if (!client) return;
    store.store.dispatch(resetIncidentFilter());
    store.store.dispatch(setIsWarningCitation('all'));
    store.store.dispatch(setIsSubmittedCitation('all'));
    store.store.dispatch(setMode('day'));
    store.store.dispatch(setIsViewError('all'));
    store.store.dispatch(setViewSubStatus('all'));
    const updatedState = store.store.getState();
    const { incidentFilter } = updatedState.uiHomeScreen;

    const payload = {
      incidentFilter,
      lastCourtDetails: null,
      isWarningCitation: 'all',
      isSubmittedCitation: 'all',
      ibrsFilter: {
        isViewError: 'all',
        viewSubStatus: 'all',
      },
    };

    const jsonValue = JSON.stringify(payload);
    let userSettings = [];

    if (updatedState.user.userData?.user.UserSettings) {
      userSettings = JSON.parse(updatedState.user.userData.user.UserSettings);
      let ptsUserSettingID;

      userSettings = userSettings.map((setting) => {
        if (setting.SettingApp === 'RMS' || setting.ApplicationName === 'RMS') {
          setting.JsonValue = jsonValue;
          ptsUserSettingID = setting.ptsUserSettingID;
        }
        return setting;
      });

      updatedState.user.userData.user.UserSettings = JSON.stringify(userSettings);

      if (ptsUserSettingID) {
        await client.service('user-settings').patch(ptsUserSettingID, { JsonValue: jsonValue });
      }
    }
  } catch (err) {
    console.error('Error resetting user settings', err);
  }
};

export const sendPassResetLink = async (username, isResendRequest = false) => {
  const client = store.store.getState().websocket.websocket;
  if (!client) {
    return;
  }
  const userIP = await detectClientIP();
  const service = client.service('pass-reset');
  // service.timeout = 40000;

  return service.create({
    action: 'pass-reset',
    email: null,
    ResetMethod: 'email',
    AppName: 'RMS',
    RedirectTo: window.__RUNTIME_CONFIG__.REACT_APP_PUBLIC_URL + '/Reset-password',
    userIP,
    username,
    isResendRequest,
  });
};

export const validateResetPassHash = (hash, username) => {
  const client = store.store.getState().websocket.websocket;
  if (!client) {
    return;
  }
  const service = client.service('pass-reset');
  // service.timeout = 40000;
  return service.get(hash, { query: { username } });
};
export const changePass = async (currentPass, newPass) => {
  const client = store.store.getState().websocket.websocket;
  if (!client) {
    return;
  }
  const userIP = await detectClientIP();

  const service = client.service('authenticate');
  return service.patch(0, { currentPass, newPass, AppName: 'RMS', userIP });
};
export const resetPass = async (code, newPass, username) => {
  const client = store.store.getState().websocket.websocket;
  if (!client) {
    return;
  }
  const userIP = await detectClientIP();

  const service = client.service('pass-reset');
  // service.timeout = 40000;
  return service.patch(code, { newPass, AppName: 'RMS', userIP, username });
};

export const setPasswordFieldShouldReset = (flag = false) => {
  return (dispatch) => {
    dispatch({ type: PASSWORD_FIELD_SHOULD_RESET, payload: flag });
  };
};

export const getAgencyIBRSVersion = (agency = 'POLICEDEP') => {
  const client = store.store.getState().websocket.websocket;
  if (!client) {
    return;
  }

  return async (dispatch) => {
    try {
      let Path = `${agency}.RMS.NIBRS.NibrsVersion`;
      const service = client.service('cdr');

      const versionData = await service.find({ query: { Path } });

      if (versionData.length > 0) {
        dispatch({ type: USER_AGENCY_NIBRS_VERSION, payload: versionData[0].ValueString });
      } else dispatch({ type: USER_AGENCY_NIBRS_VERSION, payload: 'NIBRS' });
    } catch (error) {
      console.log(error);
    }
  };
};

export const getAgencySubmissionFileFormat = (agency = 'POLICEDEP') => {
  const client = store.store.getState().websocket.websocket;
  if (!client) {
    return;
  }

  return async (dispatch) => {
    try {
      let Path = `${agency}.RMS.NIBRS.SubmissionFileFormat`;
      const service = client.service('cdr');

      const submissionFileFormat = await service.find({ query: { Path } });

      if (submissionFileFormat.length > 0) {
        dispatch({
          type: USER_AGENCY_SUBMISSON_FILE_FORMAT,
          payload: submissionFileFormat[0].ValueString,
        });
      } else dispatch({ type: USER_AGENCY_SUBMISSON_FILE_FORMAT, payload: 'SINGLE' });
    } catch (error) {
      console.log(error);
    }
  };
};

export const submitLoginForm = (username, password, reAuthUser, secondFactor) => {
  const client = store.store.getState().websocket.websocket;
  return async (dispatch) => {
    try {
      const userIP = await detectClientIP();

      let user = null;
      if (reAuthUser) {
        user = reAuthUser;
      } else if (!secondFactor) {
        user = await client.authenticate({
          strategy: 'local',
          username: username,
          password: password,
          AppName: 'RMS',
          userIP,
        });
      } else {
        user = await client.authenticate({
          strategy: 'local',
          username: username,
          password: password,
          AppName: 'RMS',
          userIP,
          otp: secondFactor,
        });
      }

      if (user) {
        let rmsSetting;

        if (user.user.UserSettings) {
          const settings = JSON.parse(user.user.UserSettings);

          rmsSetting = settings.filter(
            (setting) => setting.ApplicationName === 'RMS' || setting.SettingApp === 'RMS'
          );

          if (rmsSetting && rmsSetting.length > 0) {
            const settings = rmsSetting[0]?.ptsUserSettingID && JSON.parse(rmsSetting[0].JsonValue);
            if (rmsSetting[0]?.ptsUserSettingID && settings) {
              const { lastCourtDetails, isWarningCitation, isSubmittedCitation, ibrsFilter } = settings;

              if (lastCourtDetails) {
                const newForm = {
                  ...lastCourtDetails,
                  CourtDate: lastCourtDetails.CourtDate,
                };

                dispatch(setLastCourteDetails(newForm));
              }
              if (isWarningCitation) {
                dispatch(setIsWarningCitation(isWarningCitation));
              }
              if (isSubmittedCitation) {
                dispatch(setIsSubmittedCitation(isSubmittedCitation));
              }
              if (ibrsFilter) {
                dispatch(setIsViewError(ibrsFilter.isViewError ?? 'all'));
                dispatch(setViewSubStatus(ibrsFilter.viewSubStatus ?? 'all'));
              }
            }
          }
        }

        const service = client.service('user-settings');
        service.timeout = 20000;

        if (user.user.UserSettings === null || rmsSetting.length === 0) {
          const { fromDate, toDate } = getTimePeriod('Last 7 Days');

          let changedFromDate = fromDate;
          let changedToDate = toDate;

          filter.incidentFilter.occurredTimePeriod = 'Last 7 Days';
          filter.incidentFilter.occuredFrom = changedFromDate;
          filter.incidentFilter.occuredTo = changedToDate;

          dispatch(setOccuredFromDate(changedFromDate));
          dispatch(setOccuredToDate(changedToDate));
          dispatch(setOccurredTimePeriodValue('Last 7 Days'));

          let createObject = {
            ptsUserID: user.user.ptsUserID,
            ApplicationName: 'RMS',
            JsonValue: JSON.stringify(filter),
          };

          await service.create(createObject).then((res) => {
            let userSettings = [];

            createObject.ptsUserSettingID = res.ptsUserSettingID;
            userSettings.push(createObject);

            user.user.UserSettings = JSON.stringify(userSettings);

            logOutSent = false;
            dispatch({
              type: USER_SET_AGENCY,
              payload: user.user.AgencyID !== null ? user.user.AgencyID : '',
            });
            dispatch({ type: USER_SET_DATA, payload: user });
            dispatch({ type: USER_SET_AUTHENTICATED, payload: true });
            dispatch(updateIfNewVersionAvail());
          });
        } else {
          dispatch({
            type: USER_SET_AGENCY,
            payload: user.user.AgencyID !== null ? user.user.AgencyID : '',
          });
          dispatch({ type: USER_SET_DATA, payload: user });
          dispatch({ type: USER_SET_AUTHENTICATED, payload: true });
          // dispatch(updateIfNewVersionAvail());
        }
        dispatch({ type: USER_SECOND_FACTOR, payload: false });
        await getUserClearanceLevel(user.user.ptsClearanceLevelID);
      }
    } catch (error) {
      if (!error.data) {
        console.log(error);
        const { code, message } = error;
        switch (code) {
          case 408:
            dispatch(
              notify(
                'It takes too long to connect to the server. Please check your connection and try again.',
                'warning'
              )
            );
            break;
          case 401:
            if (message) {
              dispatch({ type: PASSWORD_FIELD_SHOULD_RESET, payload: true });
              dispatch(notify(message, 'error'));
            } else {
              dispatch(notify('Login failed. Please try again.', 'error'));
            }
            break;
          default:
            if (message) {
              dispatch(notify(message, 'error'));
            } else {
              dispatch(
                notify(`Unknown error ${code}. Please check you connection and try again.`, 'error')
              );
            }
        }
        dispatch({ type: USER_SET_AUTHENTICATED, payload: false });
      } else {
        if (error.data.secondFactor) {
          dispatch(notify('Authentication token has been sent (email)', 'warning'));
          dispatch({ type: USER_SET_AUTHENTICATED, payload: false });
          dispatch({ type: USER_SECOND_FACTOR, payload: true });
        } else {
          dispatch(
            notify(
              'It takes too long to connect to the server. Please check your connection and try again.',
              'warning'
            )
          );
        }
      }
    }
  };
};

export const setUserAuthenticated = (state) => {
  const client = store.store.getState().websocket.websocket;
  return (dispatch) => {
    if (client) {
      if (state === false) {
        localStorage.clear();
        sessionStorage.clear();
        dispatch(logOut());
      }
    }
    dispatch({ type: USER_SET_AUTHENTICATED, payload: state });
  };
};

export const setUserData = (data) => {
  return (dispatch) => {
    dispatch({ type: USER_SET_DATA, payload: data });
  };
};

export const setUserAgency = (agency) => {
  return (dispatch) => {
    dispatch({ type: USER_SET_AGENCY, payload: agency });
    dispatch(getDictionaries('rms'));
    dispatch(findUnreadUserBulletins());
  };
};

export const setAgencyReportsVersion = (agency) => {
  const { Agencies } = store.store.getState().dictionary;

  let incReportVersion = null,
    eviReportVersion = null;

  if (Agencies?.length) {
    incReportVersion = Agencies.find((a) => a.AgencyID === agency)?.IncidentReportVersion || null;
    eviReportVersion =
      Agencies.find((a) => a.AgencyID === agency)?.EvidenceLabelReportVersion || null;
  }

  return (dispatch) => {
    dispatch({ type: USER_SET_INCIDENT_REPORT_VERSION, payload: incReportVersion });
    dispatch({ type: USER_SET_EVIDENCE_LABEL_REPORT_VERSION, payload: eviReportVersion });
  };
};

export const setUserClearanceLevel = (clearanceID) => {
  return (dispatch) => {
    dispatch({ type: USER_SET_CLEARANCE_LEVEL, payload: clearanceID });
  };
};
export const setUserClearanceOptions = (clearanceOptions) => {
  return (dispatch) => {
    dispatch({ type: USER_SET_CLEARANCE_OPTIONS, payload: clearanceOptions });
  };
};

export const getUserClearanceLevel = async (clearanceID = 3) => {
  const client = store.store.getState().websocket.websocket;
  if (!client) return;
  const service = client.service('settings-sec-clearance-level');
  const res = await service.find();
  let clearanceValue = res.find((item) => item.ptsClearanceLevelID === clearanceID);

  if (!clearanceValue) clearanceValue = res.find((item) => item.Level === '0');

  const agency = store.store.getState().user.userAgency;
  const userDefaultAgency = store.store.getState().user.userData?.user.AgencyID;
  if (agency === userDefaultAgency) {
    const clearanceOptions = res.filter(
      (item) => parseInt(item.Level) <= parseInt(clearanceValue.Level)
    );
    store.store.dispatch(setUserClearanceLevel(clearanceValue));
    store.store.dispatch(setUserClearanceOptions(clearanceOptions));
  } else {
    const clearanceOption = res.reduce((min, current) =>
      parseInt(current.Level) < parseInt(min.Level) ? current : min
    );
    store.store.dispatch(setUserClearanceOptions([clearanceOption]));
    store.store.dispatch(setUserClearanceLevel(clearanceOption));
  }
};

export const isForcePasswordActiveForTheUser = async (username) => {
  const client = store.store.getState().websocket.websocket;
  if (!client) return;
  const service = client.service('settings-security-users-resetpassword');
  const result = await service.find({
    query: { username }
  });
  return Boolean(result);
};

export const setSecondFactor = (state) => {
  return (dispatch) => {
    dispatch({ type: USER_SECOND_FACTOR, payload: state });
  };
};

export const logOut = () => async (dispatch) => {
  if (logOutSent) return;
  logOutSent = true;
  try {
    const state = store.store.getState();
    const { appInfo } = state;
    const client = state.websocket.websocket;
    const userIP = await detectClientIP();

    if (client) {
      client
        .service('authenticate')
        .remove('RMS', {
          query: { userIP },
        })
        .catch((e) => {});
      client.logout();
    } else {
      window.localStorage.removeItem('auth');
    }
    resetRestClient();
    dispatch({ type: USER_CLEAR_DATA });
    dispatch({ type: USER_SET_AUTHENTICATED, payload: false });
    dispatch(resetUserPermissions());
    // check if new version of app is available and log out if so
    const { registration } = appInfo;
    if (registration) {
      updateApp(registration);
    } else {
      const { buildNo } = appInfo;
      const newVer = await checkForNewVersion();
      if (buildNo && buildNo !== newVer?.build) window.location.reload();
    }
  } catch (err) {
    console.log(err);
  }
};

export const getUserSettings = () => {
  return async (dispatch) => {
    try {
      const state = store.store.getState();
      const client = state.websocket.websocket;

      const service = client.service('user-settings');
      service.timeout = 20000;

      let localUserData = '';
      let userId = '';
      if (state.user.userData?.user.ptsUserID) {
        userId = state.user.userData?.user.ptsUserID;
        localUserData = state.user.userData;
        userId = parseInt(userId);
        const result = await service.find({
          query: {
            ptsUserID: userId,
            ApplicationName: 'RMS',
            IsDeleted: 0,
          },
        });

        if (result && result.data) {
          const jsonValue = JSON.stringify(result.data);
          localUserData = {
            ...localUserData,
            user: { ...localUserData.user, UserSettings: jsonValue },
          };
          dispatch({ type: USER_SET_DATA, payload: localUserData });
        }
      }
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

export const authorizeExternalApp = () => {
  const isProduction = window.__RUNTIME_CONFIG__.NODE_ENV !== 'development';
  const auth = window.localStorage.getItem('auth');
  const domain = window.location.hostname;
  const parentDomain = domain.substr(domain.indexOf('.') + 1);
  Cookies.set('auth', auth, {
    expires: new Date(new Date().getTime() + 5000),
    path: '/',
    domain: parentDomain,
    secure: isProduction,
  });
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    // User
    case USER_SET_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: action.payload,
      };
    case USER_SECOND_FACTOR:
      return {
        ...state,
        secondFactor: action.payload,
      };
    case USER_SET_DATA:
      return {
        ...state,
        userData: action.payload,
      };
    case USER_SET_AGENCY:
      return {
        ...state,
        userAgency: action.payload,
      };
    case USER_SET_INCIDENT_REPORT_VERSION:
      return {
        ...state,
        incidentReportVersion: action.payload,
      };
    case USER_SET_EVIDENCE_LABEL_REPORT_VERSION:
      return {
        ...state,
        evidenceLabelReportVersion: action.payload,
      };
    case USER_SET_CLEARANCE_LEVEL:
      return {
        ...state,
        userCurrentClearanceLevel: action.payload,
      };
    case USER_SET_CLEARANCE_OPTIONS:
      return {
        ...state,
        userClearanceOptions: action.payload,
      };
    case PASSWORD_FIELD_SHOULD_RESET:
      return {
        ...state,
        passwordFieldShouldReset: action.payload,
      };
    case USER_CLEAR_DATA:
      return defaultState;
    case USER_AGENCY_NIBRS_VERSION:
      return {
        ...state,
        ibrsVersion: action.payload,
      };
    case USER_AGENCY_SUBMISSON_FILE_FORMAT:
      return {
        ...state,
        submissionFileFormat: action.payload,
      };
    default:
      break;
  }
  return state;
}
